import { css } from 'styled-components';

const styles = css`
  .bonus-points-right-header {
    line-height: 20px;
    margin-top: 10px;
  }
  .bonus-points-right-header-first {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs28};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .bonus-points-right-header-second {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    font-weight: ${(props) => props.theme.fonts.fontWeight.black};
  }
`;

export default styles;
